module.exports = __webpack_public_path__ + "static/willful-logo-32aa9ca61c407d31443cc0b2dfd52b43.png";